import script from "./customerEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./customerEdit.vue?vue&type=script&setup=true&lang=js"

import "./customerEdit.vue?vue&type=style&index=0&id=3e6e88dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6e88dc"]])

export default __exports__